import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { copyToClipboard } from '../../../../../../services/copy-to-clipboard';
import { RETURN_ACTION_COPY_TRACKING_NUMBER_CLICKED } from '../../../../../../constants/analytics-events';
import { Segment } from '../../../../../../services/analytics-services/segment';

import messages from '../messages';

const CopyTrackingNumberMenuItem = ({ isEnabled, trackingNumber }) => {
  const enableItem = isEnabled && !!trackingNumber;
  const copyTrackingNumber = useCallback(() => {
    Segment.trackEvent(RETURN_ACTION_COPY_TRACKING_NUMBER_CLICKED, {
      type: RETURN_ACTION_COPY_TRACKING_NUMBER_CLICKED,
      enhanced: false,
      trackingNumber,
    });
    copyToClipboard(trackingNumber);
  }, [trackingNumber]);

  return (
    <DropdownMenuItem disabled={!enableItem} onClick={copyTrackingNumber}>
      <FormattedMessage {...messages.copyTracking} />
    </DropdownMenuItem>
  );
};

CopyTrackingNumberMenuItem.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  trackingNumber: PropTypes.string,
};

export { CopyTrackingNumberMenuItem };
